/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Asset } from './asset';

export interface TransactionLog {
  id?: number;
  assetId?: number;
  asset?: Asset;
  accountId?: number;
  account?: Account;
  change?: number;
  newBalance?: number;
  timestamp?: string;
  comment?: string;
  transferId?: number;
  orderId?: number;
  routeAckId?: number;
  newCredit?: number;
  transactionType?: TransactionLog.TransactionTypeEnum;
  refAssetCost?: number;
}
export namespace TransactionLog {
  export const TransactionTypeEnum = {
    Trade: 'TRADE',
    Transfer: 'TRANSFER',
    Revenue: 'REVENUE',
    InternalHedgeRevenue: 'INTERNAL_HEDGE_REVENUE',
  } as const;
  export type TransactionTypeEnum = (typeof TransactionTypeEnum)[keyof typeof TransactionTypeEnum];
}
